var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-base-layout',[_c('div',{staticClass:"pa-0 pb-0 pl-0 ma-0 fill-height"},[_c('v-layout',{staticClass:"fill-height",attrs:{"no-gutters":"","height":"100%","row":""}},[_c('v-col',{staticClass:"pa-0 ma-0"},[_c('nuxt')],1)],1),_vm._v(" "),_c('Snackbar'),_vm._v(" "),_c('impersonated-layout')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }